import { createTheme } from "@mui/material/styles";
import { rawColor, colors } from "../constants/colors";

export const exyboxGoldTheme = createTheme({
  name: "exyboxGold",
  palette: {
    mode: "dark",
    primary: { main: rawColor.exyboxGold.main },
    secondary: { main: rawColor.exyboxGold.secondary },
    background: {
      default: rawColor.exyboxGold.background,
      paper: rawColor.exyboxGold.paper,
    },
    text: {
      primary: rawColor.exyboxGold.text.primary,
      secondary: rawColor.exyboxGold.text.secondary,
    },
    action: {
      hover: rawColor.exyboxGold.sidebar.hover,
    },
    error: { main: rawColor.status.error.dark },
    warning: { main: rawColor.status.warning },
    success: { main: rawColor.status.active.green },
    divider: rawColor.exyboxGold.divider,
  },
  sidebar: {
    base: colors.sidebar.exyboxGold.base,
    hover: colors.sidebar.exyboxGold.hover,
    selected: colors.sidebar.exyboxGold.selected,
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: ({ theme }) => ({
          backgroundColor: theme.sidebar.base,
          borderRight: `1px solid ${theme.palette.divider}`,
          "& .MuiListItemIcon-root": {
            color: rawColor.exyboxGold.text.secondary,
          },
          "& .MuiListItemText-root": {
            color: rawColor.exyboxGold.text.secondary,
          },
          "& .MuiListItemButton-root.Mui-selected": {
            backgroundColor: theme.sidebar.selected,
            "& .MuiListItemIcon-root": {
              color: rawColor.exyboxGold.main,
            },
            "& .MuiListItemText-root": {
              color: rawColor.exyboxGold.main,
            },
          },
          "& .MuiListItemButton-root:hover": {
            backgroundColor: theme.sidebar.hover,
          },
        }),
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          backgroundColor: colors.table.exyboxGold.cell,
          color: rawColor.exyboxGold.text.secondary,
        },
        head: {
          backgroundColor: colors.table.exyboxGold.header,
          color: colors.table.exyboxGold.headerText,
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: rawColor.exyboxGold.paper,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          color: rawColor.exyboxGold.text.secondary,
        },
        h2: {
          color: rawColor.exyboxGold.text.secondary,
        },
        h3: {
          color: rawColor.exyboxGold.text.secondary,
        },
        h4: {
          color: rawColor.exyboxGold.text.secondary,
        },
        h5: {
          color: rawColor.exyboxGold.text.secondary,
        },
        h6: {
          color: rawColor.exyboxGold.text.secondary,
        },
        subtitle1: {
          color: rawColor.exyboxGold.text.secondary,
        },
        subtitle2: {
          color: rawColor.exyboxGold.text.secondary,
        },
        body1: {
          color: rawColor.exyboxGold.text.secondary,
        },
        body2: {
          color: rawColor.exyboxGold.text.secondary,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: rawColor.exyboxGold.text.secondary,
        },
        secondary: {
          color: rawColor.exyboxGold.text.secondary,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: rawColor.exyboxGold.text.secondary,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            color: "currentColor",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          color: rawColor.exyboxGold.text.secondary,
          "& .MuiSvgIcon-root": {
            color: rawColor.exyboxGold.text.secondary,
          },
        },
        icon: {
          color: rawColor.exyboxGold.text.secondary,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: rawColor.exyboxGold.text.secondary,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: rawColor.exyboxGold.divider,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: rawColor.exyboxGold.text.secondary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: rawColor.exyboxGold.main,
          },
          "& .MuiOutlinedInput-input": {
            color: rawColor.exyboxGold.text.secondary,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: rawColor.exyboxGold.text.secondary,
          "&.Mui-focused": {
            color: rawColor.exyboxGold.main,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: rawColor.exyboxGold.text.secondary,
          "& .MuiInputBase-input": {
            color: rawColor.exyboxGold.text.secondary,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: rawColor.exyboxGold.text.secondary,
          "&:hover": {
            backgroundColor: rawColor.exyboxGold.sidebar.hover,
          },
          "&.Mui-selected": {
            backgroundColor: rawColor.exyboxGold.sidebar.selected,
            color: rawColor.exyboxGold.main,
            "&:hover": {
              backgroundColor: rawColor.exyboxGold.sidebar.selected,
            },
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          color: rawColor.exyboxGold.text.secondary,
        },
        select: {
          color: rawColor.exyboxGold.text.secondary,
        },
        selectLabel: {
          color: rawColor.exyboxGold.text.secondary,
        },
        selectIcon: {
          color: rawColor.exyboxGold.text.secondary,
        },
        displayedRows: {
          color: rawColor.exyboxGold.text.secondary,
        },
        actions: {
          color: rawColor.exyboxGold.text.secondary,
          "& .MuiSvgIcon-root": {
            color: rawColor.exyboxGold.text.secondary,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiAutocomplete-option": {
            color: rawColor.exyboxGold.text.secondary,
            "&:hover": {
              backgroundColor: rawColor.exyboxGold.sidebar.hover,
            },
            '&[aria-selected="true"]': {
              backgroundColor: rawColor.exyboxGold.sidebar.selected,
              color: rawColor.exyboxGold.main,
              "&:hover": {
                backgroundColor: rawColor.exyboxGold.sidebar.selected,
              },
            },
          },
          "& .MuiAutocomplete-listbox": {
            backgroundColor: rawColor.exyboxGold.paper,
            "& .MuiAutocomplete-option": {
              padding: "8px 16px",
            },
          },
          "& .MuiAutocomplete-option .MuiTypography-root": {
            color: "inherit",
          },
          "& .MuiAutocomplete-option .MuiListItemText-root": {
            color: "inherit",
          },
        },
        paper: {
          backgroundColor: rawColor.exyboxGold.paper,
          "& .MuiAutocomplete-option": {
            color: rawColor.exyboxGold.text.secondary,
          },
        },
        listbox: {
          "& .MuiAutocomplete-option": {
            color: rawColor.exyboxGold.text.secondary,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ".select__control": {
          backgroundColor: `${rawColor.exyboxGold.paper} !important`,
          borderColor: `${rawColor.exyboxGold.divider} !important`,
          "&:hover": {
            borderColor: `${rawColor.exyboxGold.text.secondary} !important`,
          },
          "&--is-focused": {
            borderColor: `${rawColor.exyboxGold.main} !important`,
            boxShadow: `0 0 0 1px ${rawColor.exyboxGold.main} !important`,
          },
        },
        ".select__menu": {
          backgroundColor: `${rawColor.exyboxGold.paper} !important`,
          border: `1px solid ${rawColor.exyboxGold.divider} !important`,
        },
        ".select__option": {
          backgroundColor: `${rawColor.exyboxGold.paper} !important`,
          color: `${rawColor.exyboxGold.text.secondary} !important`,
          "&:hover": {
            backgroundColor: `${rawColor.exyboxGold.sidebar.hover} !important`,
          },
          "&--is-focused": {
            backgroundColor: `${rawColor.exyboxGold.sidebar.hover} !important`,
          },
          "&--is-selected": {
            backgroundColor: `${rawColor.exyboxGold.sidebar.selected} !important`,
            color: `${rawColor.exyboxGold.main} !important`,
            "&:hover": {
              backgroundColor: `${rawColor.exyboxGold.sidebar.selected} !important`,
            },
          },
        },
        ".select__multi-value": {
          backgroundColor: `${rawColor.exyboxGold.sidebar.hover} !important`,
          "&__label": {
            color: `${rawColor.exyboxGold.text.secondary} !important`,
          },
          "&__remove": {
            color: `${rawColor.exyboxGold.text.secondary} !important`,
            "&:hover": {
              backgroundColor: `${rawColor.exyboxGold.sidebar.selected} !important`,
              color: `${rawColor.exyboxGold.main} !important`,
            },
          },
        },
        ".select__placeholder": {
          color: `${rawColor.exyboxGold.text.secondary} !important`,
        },
        ".select__single-value": {
          color: `${rawColor.exyboxGold.text.secondary} !important`,
        },
        ".select__input": {
          color: `${rawColor.exyboxGold.text.secondary} !important`,
        },
        ".select__indicator": {
          color: `${rawColor.exyboxGold.text.secondary} !important`,
          "&:hover": {
            color: `${rawColor.exyboxGold.main} !important`,
          },
        },
        ".select__indicator-separator": {
          backgroundColor: `${rawColor.exyboxGold.divider} !important`,
        },
        ".select__clear-indicator": {
          color: `${rawColor.exyboxGold.text.secondary} !important`,
          "&:hover": {
            color: `${rawColor.exyboxGold.main} !important`,
          },
        },
        ".select__dropdown-indicator": {
          color: `${rawColor.exyboxGold.text.secondary} !important`,
          "&:hover": {
            color: `${rawColor.exyboxGold.main} !important`,
          },
        },
      },
    },
  },
});
